const w = window as unknown as {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Intercom: (methodName: string, options?: any) => void;
  intercomSettings: IntercomSettings;
};

// https://developers.intercom.com/installing-intercom/web/attributes-objects/#messenger-attributes
type IntercomSettings = {
  app_id: string;
  api_base: string;
  custom_launcher_selector?: string;
  alignment?: 'left' | 'right';
  vertical_padding?: number;
  horizontal_padding?: number;
  hide_default_launcher?: boolean;
  session_duration?: number;
  action_color?: string;
  background_color?: string;
};

type Company = {
  company_id?: string;
  created_at?: number;
  name?: string;
  monthly_spend?: number;
  plan?: string;
  size?: number;
  website?: string;
  industry?: string;
};

type Avatar = {
  type?: 'avatar';
  image_url?: string;
};

// https://developers.intercom.com/installing-intercom/web/attributes-objects/#data-attributes
type BootOptions = {
  api_base?: string;
  app_id?: string;
  name?: string;
  email?: string;
  user_id?: string;
  role?: string;
  environment?: 'development' | 'uat' | 'production';
  created_at?: number;
  phone?: string;
  last_request_at?: number;
  unsubscribed_from_emails?: boolean;
  language_override?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
  avatar?: Avatar;
  user_hash?: string;
  company?: Company;
  companies?: Company[];
  page_title?: string;
};

class Intercom {
  custom_launcher_selector?: string;
  constructor(settings: IntercomSettings) {
    w.intercomSettings = settings;
    this.custom_launcher_selector = settings?.custom_launcher_selector?.replace('.', '');
  }
  boot(options: BootOptions) {
    w?.Intercom?.('boot', {
      app_id: options?.app_id ?? w.intercomSettings.app_id,
      api_base: options?.api_base ?? w.intercomSettings.api_base,
      ...options,
    });
  }
  shutdown() {
    w?.Intercom?.('shutdown');
  }
  update() {
    w?.Intercom?.('update');
  }
  hide() {
    w?.Intercom?.('hide');
  }
  show() {
    w?.Intercom?.('show');
  }
  showSpace(spaceName: string) {
    w?.Intercom?.('showSpace', spaceName);
  }
  showMessages() {
    w?.Intercom?.('showMessages');
  }
  showNewMessage() {
    w?.Intercom?.('showNewMessage');
  }
  onHide() {
    w?.Intercom?.('onHide');
  }
  onShow() {
    w?.Intercom?.('onShow');
  }
  onUnreadCountChange() {
    w?.Intercom?.('onUnreadCountChange');
  }
  trackEvent() {
    w?.Intercom?.('trackEvent');
  }
  getVisitorId() {
    w?.Intercom?.('getVisitorId');
  }
  startTour(tourId: string) {
    w?.Intercom?.('startTour', tourId);
  }
  showArticle(articleId: string) {
    w?.Intercom?.('showArticle', articleId);
  }
  showNews(newsItemId: string) {
    w?.Intercom?.('showNews', newsItemId);
  }
  startSurvey(surveyId: string) {
    w?.Intercom?.('startSurvey', surveyId);
  }
  startChecklist(checklistId: string) {
    w?.Intercom?.('startChecklist', checklistId);
  }
  showTicket(ticketId: string) {
    w?.Intercom?.('showTicket', ticketId);
  }
  showConversation(conversationId: string) {
    w?.Intercom?.('showConversation', conversationId);
  }
  onUserEmailSupplied() {
    w?.Intercom?.('onUserEmailSupplied');
  }
}

export default Intercom;
